


























































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import ChangeClicker from '@/components/lfs/NewStatistics/Elements/ChangeClicker.vue';
import Highcharts from "highcharts";
import {locales} from "@/helpers/locales";
import IQuestion from "@/components/icons/IQuestion.vue";
import TooltipSimple from "@/components/UI/TooltipSimple.vue";

const statistics = namespace('newstatistics')

@Component({
  name: 'DataPerformanceStandmans',
  components: {TooltipSimple, ChangeClicker, IQuestion}
})
export default class DataPerformanceStandmans extends Vue {

  changeTypeDiagramm(type: string) {
    this.typeDiagram = type
    this.chartOptions.chart.type = type
  }

  @Prop({type: Array, default: []}) items!: any
  @Prop({type: String, default: ''}) titletable!: string
  @Prop({type: String, default: ''}) title!: string
  @statistics.Action('getScanVisitorsFormServer') protected getScanVisitorsFormServer: any

  itemCharts: any = this.items
  allCheck: boolean = false

  @Watch('filteredItems', {immediate: true, deep: true})
  getChartOptions(_: []) {
    setTimeout(() => this.updateSeries(), 100)
  }

  @Watch('allCheck')
  get(NewVal: any) {
    if (NewVal) {
      this.itemCharts.map((ele: any) => {
        ele.show = true
      })
    } else {
      this.itemCharts.map((ele: any) => {
        ele.show = false
      })
    }
  }

  @Watch('$i18n.locale', { immediate: true })
  onLocaleChanged(_: any) {
    this.updateLocale()
  }
  updateLocale() {
    this.chartOptions.chart.height = this.currentHeight
    Highcharts.setOptions({
      lang: {
        shortMonths: locales[this.$i18n.locale]
      }
    })

    this.seriesConfig.shardsWithFilledSurveysCount.name = this.$t('newstatistics.visitor_badges_scanned.badges_scanned1')
    this.seriesConfig.countOfFilledSurveys.name = this.$t('newstatistics.visitor_badges_scanned.completed_questionnaires')

    this.chartOptions.series[0] = { ...this.seriesConfig.shardsWithFilledSurveysCount, data: this.shardsWithFilledSurveysCount }
    this.chartOptions.series[1] = { ...this.seriesConfig.countOfFilledSurveys, data: this.countOfFilledSurveys }
    this.chartOptions.xAxis.categories = this.categories

    const chart: any = this.$refs.charts
    if (!chart) return
    chart.chart.update({ ...this.chartOptions })
  }

  updateSeries() {
    if (!this.itemCharts.length) return
    const chart: any = this.$refs.charts
    if (!chart) return
    chart.chart.update({
      series: [
        {
          ...this.seriesConfig.shardsWithFilledSurveysCount,
          data: this.shardsWithFilledSurveysCount
        },
        {
          ...this.seriesConfig.countOfFilledSurveys,
          data: this.countOfFilledSurveys
        }
      ],
      xAxis: {
        categories: this.categories
      }
    })
    const width = this.filteredItems.length * 70
    chart.chart.setSize(null, width < 436 ? 436 : width)
  }
  get hasStandmansWithData() {
    return this.filteredItems.some((standman: any) => standman.countOfFilledSurveys || standman.shardsWithFilledSurveysCount)
  }

  get filteredItems() {
    return this.itemCharts.filter((ele: any) => ele.show === true)
  }
  get shardsWithFilledSurveysCount() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.shardsWithFilledSurveysCount
    })
  }
  get countOfFilledSurveys() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.countOfFilledSurveys
    })
  }
  get categories() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.name
    })
  }

  get currentHeight() {
    return this.filteredItems.length > 12? String(this.filteredItems.length * 70) :'400'
  }

  seriesConfig = {
    shardsWithFilledSurveysCount: {
      color: '#CC7D7D',
      name: this.$t('newstatistics.visitor_badges_scanned.badges_scanned1'),
    },
    countOfFilledSurveys: {
      color: '#69A47B',
      name: this.$t('newstatistics.visitor_badges_scanned.completed_questionnaires'),
    }
  }

  typeDiagram = 'bar'
  chartOptions = {
    chart: {
      height: this.currentHeight,
      style: {"fontSize": "12px"},
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '40',
      marginBottom: this.typeDiagram == 'bar' ? '50' :'100',
      type: this.typeDiagram,
    },
    title: {
      text: ''
    },
    subtitle: {},
    credits: {
      enabled: false
    },
    tooltip: {
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        return '<div class="statistics-v4-tooltip">' + '<span class="statistics-v4-tooltip-title">'
          + context.x +
          '</span><br><span class="statistics-v4-tooltip-subtitle">'
          + context.point.series.name + ': ' + context.y + '</span></div>'
      },
    },
    xAxis: {
      categories: this.categories,
      gridLineDashStyle: 'dot',
      gridLineWidth: 0,
    },
    yAxis: {
      min: 0,
      allowDecimals: false,
      title: null,
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
      tickPixelInterval: 200,
    },
    legend: {
      align: 'center',
      verticalAlign: 'top',
      enabled: true,
      itemStyle: {
        fontSize: '15',
        fontWeight: '700',
        color: ' #0A0A0A',
        textOverflow: 'ellipsis'
      }
    },
    plotOptions: {
      column: {},
      bar: {
        legend: {
          enabled: true
        },
        colorByPoint: false,
        dataLabels: {
          enabled: true,
          inside: false
        }
      },
    },
    series: [
      {
        ...this.seriesConfig.shardsWithFilledSurveysCount,
        data: this.shardsWithFilledSurveysCount,
      },
      {
        ...this.seriesConfig.countOfFilledSurveys,
        data: this.countOfFilledSurveys,
      }
    ]
  }

}
